var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { formatScore } from '../utils/scoreUtil';
import { t } from 'i18next';
import { BaseComponent } from '../utils/BaseComponent';
let Score = class Score extends BaseComponent {
    render() {
        const size = this.small ? 'w-20 h-20' : 'w-40 h-40';
        const text = this.small ? 'detail' : '';
        return html `
      <trust-icon name="ScoreCircle" classNames='absolute fill-primary ${size}'></trust-icon>
      <p class='absolute flex items-center justify-center ${size} text-white ${text}'>
        ${this.score ? formatScore(this.score) : '?'}
      </p>
      <div
        class='${size} mr-${this.small ? '4' : '8'}'
        aria-label='${this.score ? t('{{score}} of 10', { score: formatScore(this.score), }) : '?'}'
      >
      </div>
    `;
    }
};
__decorate([
    property()
], Score.prototype, "score", void 0);
__decorate([
    property()
], Score.prototype, "small", void 0);
Score = __decorate([
    customElement('trust-score')
], Score);
export { Score };
//# sourceMappingURL=score.js.map